<template>
<div class="login">

	<div>
		Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-terms" :to="{name: 'policyPage'}" target="_blank">個人情報の取り扱い</router-link>について<br>
		に同意の上、ログインしてください。
    <el-checkbox v-model="isAgree" ><p style="font-size: 0.75rem; padding: 5px; padding-top: 15px; padding-bottom: 15px;color:red;">利用規約・個人情報の取り扱いについて同意する</p></el-checkbox>
	</div>
  <div class="horizontal-text"><span>IDとパスワードでログイン</span></div>
  <div class="mail-link-login">
      <el-input v-model="mailLogin.email"
          type="email"
          autocomplete
          name="mail-link-input"
          placeholder="メールアドレスを入力してください"
          :disabled="loginEmailSending"></el-input>
      <br>
      <el-input v-model="mailLogin.passwd"
          type="password"
          autocomplete
          name="mail-link-input"
          style="padding-top:10px"
          placeholder="パスワードを入力してください"
          :disabled="loginEmailSending"></el-input>

      <el-button type="primary"
        id="email-login-account-dialog"
        class="btn"
        :plain="isPlainButton"
        @click="loginIdPw(mailLogin.email, mailLogin.passwd)"
        v-loading="loginEmailSending">ログインする</el-button>
  </div>
  <div class="horizontal-text"><span>ソーシャル会員登録・ログイン</span></div>
  <div class="text-right">
    <el-button type="primary"
      id="google-login-account-dialog"
      class="button-block"
      style="background-color:#fff;border-color:#000;color:#000;font-size: 15px;padding:10px 0;vertical-align:middle;"
      :plain="isPlainButton"
      @click="signInGoogle();"><img src="/static/renew_img/icon/google.png" style="width:40px;vertical-align: middle;" >　Googleアカウントで<br>会員登録・ログイン</el-button>
  </div>
  <p class="addition">ご利用のGoogleアカウントで会員登録・ログインできます</p>
  <div class="text-right"
        v-if="$site.appFlag!='b' && getMode != 'production1'">
    <el-button type="primary"
      id="google-login-account-dialog"
      class="button-block"
      style="background-color:#fff;border-color:#000;color:#000;font-size: 15px;padding:10px 0;vertical-align:middle;"
      :plain="isPlainButton"
      @click="signInLine();"><img src="/static/renew2_img/line_icon.jpeg" style="width:40px;vertical-align: middle;" >　LINEで会員登録・ログイン</el-button>
  </div>
  <p class="addition"
        v-if="$site.appFlag!='b' && getMode != 'production1'">ご利用のLINEアカウントで会員登録・ログインできます</p>
  <div class="text-right">
    <el-button type="primary"
      id="google-login-account-dialog"
      class="button-block"
      style="background-color:#fff;border-color:#000;color:#000;font-size: 15px;padding:10px 0;vertical-align:middle;"
      :plain="isPlainButton"
      @click="signInApple();"><img src="/static/renew_img/icon/appleinc.png" style="width:40px;vertical-align: middle;" >　AppleIDで会員登録・ログイン</el-button>
  </div>
  <p class="addition">ご利用のAppleアカウントで会員登録・ログインできます</p>
  <div class="text-right"
        v-if="getMode != 'production'">
    <el-button type="primary"
      id="google-login-account-dialog"
      class="button-block"
      style="background-color:#fff;border-color:#000;color:#000;font-size: 15px;padding:10px 0;vertical-align:middle;"
      :plain="isPlainButton"
      @click="signInFacebook();"><img src="/static/renew_img/icon/facebook.png" style="width:40px;vertical-align: middle;" >　Facebookでログイン</el-button>
  </div>
  <p class="addition"
        v-if="getMode != 'production'">ご利用のFacebookアカウントでログインできます</p>
  <div class="horizontal-text" v-if="$site.appFlag!='b'"><span>または</span></div>
  <div class="mail-link-login" v-if="$site.appFlag!='b'">
    <el-form ref="mailLoginForm"
      :model='mailLogin'
      :rules='mailLoginRules'
      @submit.native.prevent>
      <el-form-item :required='true'
        prop='email'>
        <el-input v-model="mailLogin.email"
          type="email"
          autocomplete
          name="mail-link-input"
          placeholder="yagish@example.com"
          :disabled="loginEmailSending"></el-input>
      </el-form-item>
      <el-button type="primary"
        id="email-login-account-dialog"
        class="button-block"
        :plain="isPlainButton"
        @click="mailSubmit"
        v-loading="loginEmailSending">メールでリンクを送る</el-button>
    </el-form>
    <p class="addition">メールに届いたリンクをクリックするだけでかんたんに会員登録・ログインできます。</p>
  </div>
</div>
</template>
<style lang="scss" scoped>
$light-gray: #dcdfe6;
.login {
  max-width: 320px;
  margin: .5rem auto;
  border-radius: .25rem;
  border: solid 1px $light-gray;
  padding: 1rem;
  box-sizing: border-box;
  button {
    margin-top: .5rem;
  }
  .el-form-item {
    margin: 0;
  }
  .addition {
    font-size: .75rem;
    margin: .5rem 0;
  }
}
</style>
<style lang="scss">
.login {
  .el-input {
    position: static;
  }
  .el-form-item__error {
    position: static;
    text-align: left;
  }
}
</style>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      isAgree: false,
      mailLogin: {
        email: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      this.$refs.mailLoginForm.resetFields()
    },
    mailSubmit: function () {
      if (!this.isAgree) {
        this.$message({
          message: '同意するチェックボックスにチェックをしてからログインしてください。',
          type: 'error'
        })
        return
      }
      const app = this
      this.$refs.mailLoginForm.validate(async valid => {
        if (!valid) {
          return
        }
        app.$firebase.signInEmail(app.mailLogin.email)
        app.loginEmailSending = true
      })
    },
    loginIdPw: function (id, pw) {
      if (!this.isAgree) {
        this.$message({
          message: '同意するチェックボックスにチェックをしてからログインしてください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      this.$firebase.signInEmailPasswd(id, pw)
    },
    signInGoogle: function () {
      if (!this.isAgree) {
        this.$message({
          message: '同意するチェックボックスにチェックをしてからログインしてください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      this.$firebase.signInGoogle()
    },
    signInLine: function () {
      if (!this.isAgree) {
        this.$message({
          message: '同意するチェックボックスにチェックをしてからログインしてください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      this.$firebase.signInLine()
    },
    signInApple: function () {
      if (!this.isAgree) {
        this.$message({
          message: '同意するチェックボックスにチェックをしてからログインしてください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      this.$firebase.signInApple()
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>
